 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"accessLogs~addOrEditNews~adminMessage~apiKey~contractMaster~dashboard~editScrip~fileUpload~logDetail~3ed3b7c2":"accessLogs~addOrEditNews~adminMessage~apiKey~contractMaster~dashboard~editScrip~fileUpload~logDetail~3ed3b7c2","apiKey":"apiKey","accessLogs":"accessLogs","addOrEditNews":"addOrEditNews","adminMessage":"adminMessage","contractMaster":"contractMaster","dashboard":"dashboard","editScrip":"editScrip","fileUpload":"fileUpload","logDetails":"logDetails","reports":"reports","login~positionAvg~userLogs":"login~positionAvg~userLogs","login":"login","positionAvg~updateVendor":"positionAvg~updateVendor","positionAvg":"positionAvg","updateVendor":"updateVendor","chartData":"chartData","scheduler~userLogs":"scheduler~userLogs","scheduler":"scheduler","userLogs":"userLogs","sectorDetails":"sectorDetails"}[chunkId]||chunkId) + "." + {"chunk-7ca38a5a":"ed7cc60e","accessLogs~addOrEditNews~adminMessage~apiKey~contractMaster~dashboard~editScrip~fileUpload~logDetail~3ed3b7c2":"560f0c33","chunk-631d8c11":"214a36f2","apiKey":"cfd6ce56","chunk-77aee3ff":"1801f448","accessLogs":"c3d05e75","addOrEditNews":"ea07551c","adminMessage":"00c8bdeb","contractMaster":"13586c43","dashboard":"57d683c1","editScrip":"9f2fa21e","fileUpload":"5faf07fc","logDetails":"983455f1","reports":"093edd65","login~positionAvg~userLogs":"eab51a11","login":"3e5e73f3","positionAvg~updateVendor":"f3b69178","positionAvg":"258dd93c","updateVendor":"ac52ccc0","chartData":"70b58366","chunk-3c07fbec":"c8738de0","chunk-2411d87e":"cc02f06b","scheduler~userLogs":"fa5eedd3","scheduler":"9d15c9f1","userLogs":"e2fc2512","sectorDetails":"582006a7","chunk-130b2878":"f321f942","chunk-4ff5d7d8":"7e1ce49b","chunk-13086d15":"ae4e9411","chunk-130a112b":"335c25f0","chunk-131f2dfe":"694a24fd","chunk-24177dfa":"d0b5c462","chunk-58d6436f":"a71a1005","chunk-8b071366":"e6a67be9","chunk-2bfeba54":"265bbff8","chunk-7ec494e8":"f453e02a","chunk-fa8970ce":"a32561fc"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-7ca38a5a":1,"accessLogs~addOrEditNews~adminMessage~apiKey~contractMaster~dashboard~editScrip~fileUpload~logDetail~3ed3b7c2":1,"chunk-631d8c11":1,"apiKey":1,"chunk-77aee3ff":1,"accessLogs":1,"addOrEditNews":1,"adminMessage":1,"contractMaster":1,"dashboard":1,"editScrip":1,"fileUpload":1,"logDetails":1,"reports":1,"login~positionAvg~userLogs":1,"login":1,"positionAvg~updateVendor":1,"positionAvg":1,"updateVendor":1,"chartData":1,"chunk-3c07fbec":1,"chunk-2411d87e":1,"scheduler~userLogs":1,"scheduler":1,"userLogs":1,"sectorDetails":1,"chunk-4ff5d7d8":1,"chunk-58d6436f":1,"chunk-2bfeba54":1,"chunk-7ec494e8":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"accessLogs~addOrEditNews~adminMessage~apiKey~contractMaster~dashboard~editScrip~fileUpload~logDetail~3ed3b7c2":"accessLogs~addOrEditNews~adminMessage~apiKey~contractMaster~dashboard~editScrip~fileUpload~logDetail~3ed3b7c2","apiKey":"apiKey","accessLogs":"accessLogs","addOrEditNews":"addOrEditNews","adminMessage":"adminMessage","contractMaster":"contractMaster","dashboard":"dashboard","editScrip":"editScrip","fileUpload":"fileUpload","logDetails":"logDetails","reports":"reports","login~positionAvg~userLogs":"login~positionAvg~userLogs","login":"login","positionAvg~updateVendor":"positionAvg~updateVendor","positionAvg":"positionAvg","updateVendor":"updateVendor","chartData":"chartData","scheduler~userLogs":"scheduler~userLogs","scheduler":"scheduler","userLogs":"userLogs","sectorDetails":"sectorDetails"}[chunkId]||chunkId) + "." + {"chunk-7ca38a5a":"6f207f11","accessLogs~addOrEditNews~adminMessage~apiKey~contractMaster~dashboard~editScrip~fileUpload~logDetail~3ed3b7c2":"c9f5a90d","chunk-631d8c11":"dcc009ac","apiKey":"52a40223","chunk-77aee3ff":"35195727","accessLogs":"353b1a7a","addOrEditNews":"c32c5fb9","adminMessage":"eac3b0af","contractMaster":"78587f69","dashboard":"129486fb","editScrip":"a4163a12","fileUpload":"c5d252ad","logDetails":"c6c65772","reports":"1e7ba6e2","login~positionAvg~userLogs":"fae4c610","login":"b7216c88","positionAvg~updateVendor":"8d38f88b","positionAvg":"c5105698","updateVendor":"f0222215","chartData":"5bf7f06c","chunk-3c07fbec":"c45b0583","chunk-2411d87e":"cb2fbedf","scheduler~userLogs":"ec726fcc","scheduler":"2ba48411","userLogs":"aaa448ce","sectorDetails":"edb94bbf","chunk-130b2878":"31d6cfe0","chunk-4ff5d7d8":"3f75e844","chunk-13086d15":"31d6cfe0","chunk-130a112b":"31d6cfe0","chunk-131f2dfe":"31d6cfe0","chunk-24177dfa":"31d6cfe0","chunk-58d6436f":"cfd57da1","chunk-8b071366":"31d6cfe0","chunk-2bfeba54":"366069da","chunk-7ec494e8":"0b94f07b","chunk-fa8970ce":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
